import Vue from "vue";
import App from "./App.vue";
import VueGapi from "vue-gapi";
import vuetify from "./plugins/vuetify";

const clientConfig = {
  apiKey: "AIzaSyDX_dMyQ9asi_Wy9s29qNJ8YIakcfIUi_E",
  clientId: "417848614112-hvkn9hl4froimp35gtjbcfpbkod5sh4c.apps.googleusercontent.com",
  discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"],
  scope: "https://www.googleapis.com/auth/calendar.events.owned",

  // works only with `ux_mode: "prompt"`
  refreshToken: true,
};

// Use the plugin and pass along the configuration
Vue.use(VueGapi, clientConfig);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
